import { render, staticRenderFns } from "./SupplierDialog.vue?vue&type=template&id=10c72dce"
import script from "./SupplierDialog.vue?vue&type=script&lang=js"
export * from "./SupplierDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports